import React, { Suspense, lazy } from "react";
import { MainLayout } from "~/components/layout/layout.jsx";
import { Loader } from "~/components/loader/loader.jsx";

const AdminRoutes = lazy(() => import("./Router.jsx"));

export default function AdminRoutesRender({ children = [] }) {
  return (
    <MainLayout>
      <Suspense fallback={<Loader />}>
        <AdminRoutes>{children}</AdminRoutes>
      </Suspense>
    </MainLayout>
  );
}
